// @flow
import React, { Component } from "react";
import withStyles from "elevate-ui/withStyles";
import classNames from "classnames";
import KeyboardArrowDown from "elevate-ui-icons/KeyboardArrowDown";
import KeyboardArrowUp from "elevate-ui-icons/KeyboardArrowUp";
import MultiSelect from "elevate-ui/MultiSelect";
import { FastField } from "formik";
import enhanceWithClickOutside from "react-click-outside";
import find from "lodash/find";

import Dropdown from "./Dropdown";

type $Props = {
  className?: string,
  classes: Object,
  values: Object,
  query?: Object,
  mlsApiVersion: number,
};

type $State = {
  cities: Array<Object>,
  isOpen: boolean,
  filterObject: Object,
};

class Cities extends Component<$Props, $State> {
  fastFieldId = "cities";
  fastFieldName = "cities";

  constructor(props) {
    super(props);

    const filterObject = find(props.filters, (filter) => {
      if (this.props.mlsApiVersion === 1) {
        return filter.key === "city";
      } else {
        return filter.key === "cityID";
      }
    });

    this.state = {
      isOpen: false,
      filterObject,
      cities: filterObject.options,
    };

    if (this.props.mlsApiVersion === 2) {
      this.fastFieldId = "cityID";
      this.fastFieldName = "a_cityID";
    }
  }

  toggleDropdown = () => {
    this.setState((state) => ({ isOpen: !state.isOpen }));
  };

  handleClickOutside() {
    if (this.state.isOpen) {
      this.setState({ isOpen: false });
    }
  }

  renderDisplayText = (values: Object) => {
    //If we query cities with the query city id  take into account that cities here should be replaced for a_cityID
    //And this will show cities as a number. Cities name can be sucked via the ID and the state.
    //Example this.state.cities = [{value: 282, label: "Adjuntas, Puerto Rico", docCount: 7}]
    //So cityID 282 can be used to get the prev object and display the label.
    if (this.props.mlsApiVersion === 2) {
      let cityObj;
      let cityName = "";
      if (values.a_cityID[0]) {
        if (this.state.cities.length >= 1) {
          cityObj = this.state.cities.filter((city) => {
            return city.value === values.a_cityID[0];
          })[0];
          cityName = cityObj.label;
        }
        if (values.a_cityID.length > 1) {
          return `${cityName} + more`;
        }

        if (values.a_cityID && values.a_cityID.length === 1) {
          return cityName;
        }
      }
      return "All Cities";
    } else {
      if (values.cities && values.cities.length > 1) {
        return `${values.cities[0]} + more`;
      } else if (values.cities && values.cities.length === 1) {
        return values.cities;
      } else {
        return "All Cities";
      }
    }
  };

  render() {
    const { className, classes, values } = this.props;
    const { cities, isOpen } = this.state;
    return (
      <div className={classes.container} onClick={this.handleClickOutside}>
        <div
          className={classNames(classes.root, className)}
          onClick={this.toggleDropdown}
        >
          {this.renderDisplayText(values)}{" "}
          {this.state.isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </div>
        <Dropdown isOpen={isOpen} maxWidth={450}>
          <div className={classes.fieldContainer}>
            <FastField
              id={this.fastFieldId}
              name={this.fastFieldName}
              label="Cities"
              component={MultiSelect}
              items={cities}
              className={classes.multiselect}
              tags={true}
            />
          </div>
        </Dropdown>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    display: "flex",
    flexRow: "row nowrap",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    width: 245,
    height: 48,
    margin: "8px auto 16px",
    padding: "8px 12px",
    color: theme.typography.bodyColor,
    fontFamily: "inherit",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "20px",
    backgroundColor: "#fff",
    border: theme.borders["default"],
    borderRadius: theme.globalBorderRadius,
    cursor: "default",
  },
  container: {
    position: "relative",
  },
  fieldContainer: {
    width: "100%",
  },
  multiselect: {
    minWidth: 175,
    width: "100%",
  },
});

export default withStyles(styles, { name: "Cities" })(
  enhanceWithClickOutside(Cities)
);
